import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { map, pluck } from 'rxjs/operators';

import type { Placement } from '@recruitee/placements-types';

@Injectable({ providedIn: 'root' })
export class QuickEvaluationContextService {
  constructor(private activatedRoute: ActivatedRoute) {}

  public findPlacement(placements: Placement[]) {
    return this.activatedRoute.queryParams.pipe(
      pluck('offerId'),
      map(offerId =>
        offerId
          ? placements.find(placement => placement.offerId === Number(offerId))
          : placements && placements.length
            ? placements[0]
            : undefined,
      ),
    );
  }
}
